// Theme color sanitization helpers: we whitelist standard color syntaxes so
// untrusted DB values cannot inject arbitrary CSS via delimiters like '}' or ';'.
const HEX_COLOR_REGEX = /^#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
const RGB_COMPONENT = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)';
const RGB_ALPHA = '(?:0|1|0?\\.\\d+)';
const HUE = '(?:360|3[0-5]\\d|[12]\\d\\d|\\d?\\d)';
const HSL_PERCENT = '(?:100|\\d?\\d)';
const RGB_COLOR_REGEX = new RegExp(
  `^rgba?\\(\\s*${RGB_COMPONENT}\\s*,\\s*${RGB_COMPONENT}\\s*,\\s*${RGB_COMPONENT}(?:\\s*,\\s*${RGB_ALPHA})?\\s*\\)$`,
  'i'
);
const HSL_COLOR_REGEX = new RegExp(
  `^hsla?\\(\\s*${HUE}\\s*,\\s*${HSL_PERCENT}%\\s*,\\s*${HSL_PERCENT}%(?:\\s*,\\s*${RGB_ALPHA})?\\s*\\)$`,
  'i'
);

const RESTAURANT_COLOR_SANITIZE_REGEXES = [
  HEX_COLOR_REGEX,
  RGB_COLOR_REGEX,
  HSL_COLOR_REGEX
];

const sanitizeRestaurantThemeColor = (color) => {
  if (typeof color !== 'string') return null;

  const trimmedColor = color.trim();

  if (!trimmedColor) return null;

  // Return the color only when it matches one of the safe patterns, otherwise ignore it.
  return RESTAURANT_COLOR_SANITIZE_REGEXES.some(regex => regex.test(trimmedColor)) ?
    trimmedColor :
    null;
};

export default sanitizeRestaurantThemeColor;
